@import '../../../globals/main.scss';
@import './pn-proxio-productcard-common.scss';

pn-proxio-productcard-pricelink {
  align-self: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 2rem 1rem;
  gap: 0.8rem;
  align-content: center;
  flex-wrap: wrap;

  @media screen and (max-width: $productcard-media-tablet) {
    margin: 2.4rem 1rem;
  }

  h3 {
    font-size: 2rem;
  }

  pn-button {
    min-width: 17.3rem;

    a .pn-button-content {
      font-size: 1.4rem;
      font-weight: 500;
    }

    @media screen and (max-width: $productcard-media-tablet) {
      min-width: 30rem;
    }
  }

  .pn-pricelink-vat {
    font-weight: 400;
  }
}
